export const LOGOUT_URL: string = process.env.PARCEL_LOGOUT_URL ?? "";
export const LOGIN_URL: string = process.env.PARCEL_LOGIN_URL ?? "";
export const PORTAL_URL: string = process.env.PARCEL_PORTAL_URL ?? "";
export const MIXPANEL_TOKEN: string = process.env.PARCEL_MIXPANEL_TOKEN ?? "";
export const MIXPANEL_SESSION_RECORDING: number = parseInt(
  process.env.PARCEL_MIXPANEL_SESSION_RECORDING ?? "0",
  10,
);
export const MIXPANEL_LOGGING_ENABLED: boolean =
  process.env.PARCEL_MIXPANEL_LOGGING_ENABLED === "true";
